/* FFL CUSTOM — external audit item 37, 2026-09-20.
 *
 * Lighthouse reports an <iframe> with no title on the homepage and the product template. Every
 * iframe the THEME renders already has one, so the offender is injected at runtime by a
 * third-party embed (chat, reviews, payment). We cannot add a title attribute to markup we do
 * not author, and we should not silence the audit by relabelling the footer map.
 *
 * So: watch for iframes appearing in the DOM and give any untitled one an accurate, specific
 * name derived from its source host. A screen reader then announces "Live chat" rather than
 * an anonymous frame. Frames that are purely technical (tracking pixels, zero-size) are marked
 * aria-hidden instead, which is the honest description of their function.
 *
 * Deliberately not a blanket title="iframe": a meaningless label passes the audit and helps
 * nobody.
 */
(function () {
  'use strict';

  var NAMES = [
    [/judge\.?me/i, 'Customer reviews'],
    [/youtube|youtu\.be/i, 'Video player'],
    [/vimeo/i, 'Video player'],
    [/google\.com\/maps|maps\.google/i, 'Showroom location map'],
    [/tawk|crisp|intercom|tidio|roarchat|social-?chat|whatsapp/i, 'Live chat'],
    [/shop\.app|shopify.*pay|paypal|stripe|klarna|affirm/i, 'Payment options'],
    [/instagram|instafeed/i, 'Instagram feed'],
    [/recaptcha|hcaptcha/i, 'Security check'],
  ];

  function describe(frame) {
    var src = frame.getAttribute('src') || frame.getAttribute('data-src') || '';
    for (var i = 0; i < NAMES.length; i++) {
      if (NAMES[i][0].test(src)) return NAMES[i][1];
    }
    return null;
  }

  function isDecorative(frame) {
    // zero-size or explicitly hidden frames carry no content for a user
    var r = frame.getBoundingClientRect();
    var hidden = frame.getAttribute('aria-hidden') === 'true'
      || frame.style.display === 'none'
      || frame.style.visibility === 'hidden';
    return hidden || (r.width <= 2 && r.height <= 2);
  }

  function label(frame) {
    if (!frame || frame.dataset.fflTitled === '1') return;
    if (frame.hasAttribute('title') && frame.getAttribute('title').trim() !== '') return;

    if (isDecorative(frame)) {
      // a tracking/utility frame is not content: hide it from the accessibility tree
      frame.setAttribute('aria-hidden', 'true');
      frame.setAttribute('tabindex', '-1');
    } else {
      var name = describe(frame);
      // only label what we can name accurately; an unnamed visible frame is reported, not guessed
      if (name) frame.setAttribute('title', name);
      else if (window.console && console.debug) {
        console.debug('[ffl-a11y] untitled iframe with an unrecognised source:', frame.src || '(no src)');
      }
    }
    frame.dataset.fflTitled = '1';
  }

  function sweep(root) {
    var frames = (root || document).querySelectorAll('iframe');
    for (var i = 0; i < frames.length; i++) label(frames[i]);
  }

  function boot() {
    sweep(document);
    if (!window.MutationObserver) return;
    // third-party frames arrive well after DOMContentLoaded
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'IFRAME') label(n);
          else if (n.querySelectorAll) sweep(n);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
